import { Col, Row } from 'components/Core/Grid';
import Button from 'components/Core/Button';
import styled from 'styled-components';

export const WorkshopColumn = styled(Col)`
  &.grid {
    margin: 20px !important;
    padding: 0 !important;
    width: calc(33.3333% - 40px) !important;
  }

  margin: 10px 0;
`;

export const WorkshopRow = styled(Row)`
  margin-bottom: 25px !important;
  border-bottom: 1px solid var(--grey-4) !important;
  justify-content: center;
  max-width: 100%;
  margin: 0 !important;

  @media (max-width: 767px) {
    padding-bottom: 25px !important;
  }
  .image-row {
    display: none;
    padding: 0 !important;
  }
  .workshop-content {
    width: 100%;
  }
  .workshop-content--register-button-container {
    text-align: right;
    display: inline;
    padding: 0 !important;
  }
  .content-container {
    width: 83.333%;
  }

  &.grid {
    .image-row {
      display: inline;
    }
    border-bottom: none !important;

    .workshop-content {
      box-shadow: 0px 15px 40px 0px #00000040;
      padding: 30px;
      > div {
        padding-right: 0;
      }
      .content-container {
        height: 260px;
        display: flex;
        flex-direction: column;

        > div {
          overflow: hidden;
          flex: 1;
        }
      }
      .Helm-Icon > svg {
        display: none;
      }
      .Video__playButton {
        padding: 16px 12px;
      }
    }

    .workshop-content--register-button-container {
      text-align: left;
      padding: 0 !important;
    }
  }

  @media (max-width: 575px) {
    .workshop-content--register-button-container {
      text-align: left;
    }
  }
`;

export const WorkshopContentCol = styled(Col)`
  padding: 0 0 20px 0 !important;

  @media (min-width: 768px) {
    padding-right: 150px;
  }
`;

export const VideoCol = styled(Col)`
  text-align: right;
  @media (max-width: 767px) {
    text-align: center;
  }
  .Video__playButton {
    padding: 28px 0px;
    @media (max-width: 767px) {
      padding: 17px 0;
    }
    > span {
      font-size: var(--font-size-16);
    }
  }
  svg {
    width: 12px;
    height: 12px;
  }
  .Helm-Icon {
    line-height: var(--line-height-100);
    @media (max-width: 767px) {
      > svg {
        display: none;
      }
    }
  }
`;

export const RegisterButton = styled(Button)`
  text-align: center;
  line-height: var(--line-height-120);

  @media (max-width: 767px) {
    display: flex;
    width: max-content;
    margin-bottom: 15px;
  }
`;
